import { useTranslation } from "react-i18next"
import { useConfirmation } from "../../../context/useConfirmationContext"
import { EDeliveryStatusType } from "../../../Enum/EDeliveryStatusType"
import { DeliveryEntity } from "../../../Objects/DeliveryEntity/DeliveryEntity"

interface RenderDeliveryDetailsProps {
  delivery: DeliveryEntity
  onCancelSearch: (deliveryId: number) => void
}

export const RenderDeliveryDetails: React.FC<RenderDeliveryDetailsProps> = ({ delivery, onCancelSearch }) => {
  const { t } = useTranslation("fulfillment")
  const { setNewConfirmation } = useConfirmation()
  const isFindingCourier = delivery.IsFindingCourier()
  const canCancel = isFindingCourier || delivery.status === EDeliveryStatusType.Accepted

  return (
    <div className="rounded-2xl bg-white p-4 ring-2 ring-slate-200">
      <div className="mb-3 flex items-center justify-between">
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">{t("delivery")}</span>

        <span className="rounded-full bg-blue-100 px-3 py-1 text-xs font-bold text-blue-800">
          {t(`delivery_statuses.${delivery.status}`)}
        </span>
      </div>

      {isFindingCourier ? (
        <div className="flex items-center gap-3 border-t border-slate-200 pt-3">
          <div className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-orange-500" />

          <span className="text-sm font-medium text-gray-600">{t("searching_couriers")}</span>
        </div>
      ) : (
        <div className="space-y-2 text-sm">
          <div className="flex justify-between gap-2">
            <span className="text-slate-500">{t("courier")}</span>

            <span className="font-semibold text-slate-800">{delivery.courierEntity?.personEntity?.name ?? t("waiting")}</span>
          </div>

          {delivery.estimatedDistanceKm !== undefined && (
            <div className="flex justify-between">
              <span className="text-slate-500">{t("distance")}</span>

              <span className="font-semibold text-slate-800">{delivery.estimatedDistanceKm.toFixed(2)} km</span>
            </div>
          )}
        </div>
      )}

      {canCancel && (
        <button
          onClick={() =>
            setNewConfirmation(
              isFindingCourier ? t("cancel_search_title") : t("cancel_delivery"),
              isFindingCourier ? t("cancel_search_message") : t("cancel_delivery_message"),
              () => onCancelSearch(delivery.id),
            )
          }
          className="mt-3 w-full rounded-lg border border-red-200 bg-red-50 py-2 text-xs font-bold text-red-600 hover:bg-red-100"

                  data-interaction-description-key="interactionDescriptions:pages.fulfillmentPage.components.renderDeliveryDetails.button.setNewConfirmationIsFindingCourierTCancelSearchTitleTCancelDeliveryIsFindingCourierTCancelSearchMessageTCancelDeliveryMessageOnCancelSearchDeliveryId">
          {isFindingCourier ? t("cancel_search") : t("cancel_delivery")}
        </button>
      )}
    </div>
  )
}
